import axios from 'axios';
import { toast } from 'react-toastify';
import { URL_EMAIL, EMAIL_SUPORTE } from '../config/urls';

class Mail {
  // Gerar URL em arquivo
  static urltoFile(url, filename, mimeType) {
    return fetch(url)
      .then(function (res) {
        return res.arrayBuffer();
      })
      .then(function (buf) {
        return new File([buf], filename, { type: mimeType });
      });
  }
  static templateLiberacaoPlanilhaQtd() {
    return `
			<html><body><table width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td align='center'> <table style='max-width:600px' width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td style='padding:0px' valign='top' align='center'> <div style='margin:0px;display:table-cell;vertical-align:top;width:600px'> <table style='margin:0px;width:600px' width='100%' cellspacing='0' cellpadding='0' border='0' align='center'> <tbody> <tr> <td align='center'> <table width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td style='padding:15px 0px 5px;font-size:14px;font-family:arial,helvetica,sans-serif;line-height:1'> <p style='margin:0px;text-align:center;line-height:inherit'><span style='color:rgb(255,160,122)'><span style='font-size:36px'><b><span style='font-family:oswald,sans-serif'>Olá!</span></b></span> </span> </p><p style='margin:0px;text-align:center;line-height:inherit'><span style='font-size:28px'>Comissão de formatura</span></p><p style='margin:0px;text-align:center;line-height:inherit'><span style='font-size:20px'><b></b></span></p></td></tr></tbody> </table> </td></tr></tbody> </table> </div></td></tr></tbody> </table> </td></tr><tr> <td align='center'> <table style='max-width:600px' style='margin:0px;display:table-cell;vertical-align:top;width:600px'> <table style='margin:0px;width:600px' width='100%' cellspacing='0' cellpadding='0' border='0' align='center'> <tbody> <tr> <td align='center'> <center> <table width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td style='padding:15px 0px' align='center'> <table width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td style='line-height:0;border-top:1px solid rgb(204,204,204)'>&nbsp;</td></tr></tbody> </table> </td></tr></tbody> </table> </center> </td></tr></tbody> </table> </table> </td></tr><tr> <td align='center'> <table width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td style='padding:0px' valign='top' align='center'> <div style='margin:0px;display:table-cell;vertical-align:top;width:600px'> <table style='margin:0px;width:600px' width='100%' cellspacing='0' cellpadding='0' border='0' align='center'> <tbody> <tr> <td align='center'> <table width='100%'> <tbody> <tr> <td style='padding:0px' align='center'> <table cellspacing='0' cellpadding='0' border='0' align='center'> <tbody> <tr> <td style='padding:0px'> <img src='https://alphaplay.alphaconvites.com.br/imagens-marketing/email-agencia/planilha_quantidade.png' width='100%'/></td></tr></tbody> </table> </td></tr></tbody> </table> </td></tr></tbody> </table> </div></td></tr></tbody> </table> </td></tr><tr> <td align='center'> <table class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105wrapper m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105body' width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105side-border' style='padding:0px' valign='top' align='center'> <div class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-wrapper m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-col m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-twelve m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-last' style='margin:0px;display:table-cell;vertical-align:top;width:600px'> <table class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-wrapper m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-col m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-twelve' style='margin:0px;width:600px' width='100%' cellspacing='0' cellpadding='0' border='0' align='center'> <tbody> <tr> <td align='center'> <table class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105wysiwyg' width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td style='padding:28px 0px 0px;font-size:14px;font-family:arial,helvetica,sans-serif;line-height:1'> <p style='margin:0px;text-align:center;line-height:inherit'><b><span style='font-size:24px;font-weight: 500;'>A planilha de quantidades foi liberada! </span></b></p><p style='margin:0px;text-align:center;line-height:inherit'><b><span style='font-size:24px;font-weight: 500;'>Acesse o sistema para confirmá-la. </span></b></p><p style='margin:0px;line-height:inherit'></p><p style='margin:0px;line-height:inherit'></p><p style='margin:0px;line-height:inherit'></p><p style='margin:0px;line-height:inherit'></p></td></tr></tbody> </table> <center> <table width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td style='padding:15px 0px' align='center'> <table class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105divisor' width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td style='line-height:0;border-top:1px solid rgb(204,204,204)'>&nbsp;</td></tr></tbody> </table> </td></tr></tbody> </table> </center> <table class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-wrapper m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-col m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-twelve' style='margin:0px;width:600px' width='100%' cellspacing='0' cellpadding='0' border='0' align='center'> <tbody> <tr> <td align='center'> <table class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105wysiwyg' width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td style='font-size:14px;font-family:arial,helvetica,sans-serif;line-height:1'> <p style='margin:0px;text-align:center;line-height:inherit'><b><span style='font-size:18px; color: red;font-weight: 500;'>IMPORTANTE: Vamos produzir exatamente a quantidade informada para todas as pessoas que constam na planilha! Por favor, não se esqueça de ninguém! </span></b></p><p style='margin:0px;line-height:inherit'></p><p style='margin:0px;line-height:inherit'></p><p style='margin:0px;line-height:inherit'></p><p style='margin:0px;line-height:inherit'></p></td></tr></tbody> </table> <center> <table width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td style='padding:15px 0px' align='center'> <table class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105divisor' width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td style='line-height:0;border-top:1px solid rgb(204,204,204)'>&nbsp;</td></tr></tbody> </table> </td></tr></tbody> </table> </center> </td></tr></tbody> </table> </div></td></tr></tbody> </table> </td></tr><tr> <td align='center'> <table class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105wrapper m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105body' width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105side-border' style='padding:0px' valign='top' align='center'> <div class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-wrapper m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-col m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-twelve m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-last' style='margin:0px;display:table-cell;vertical-align:top;width:600px'> <table class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-wrapper m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-col m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105he-twelve' style='margin:0px;width:600px' width='100%' cellspacing='0' cellpadding='0' border='0' align='center'> <tbody> <tr> <td align='center'> <table class='m_-908527084322052884m_4053033585403127131m_-5827517981637746111m_-4918024433584667186m_7346904884360820434gmail-m_-1713301161432322998m_-4711353973809454326m_-1558844019036623105wysiwyg' width='100%' cellspacing='0' cellpadding='0' border='0'> <tbody> <tr> <td style='padding:15px 0px 0px;font-size:14px;font-family:arial,helvetica,sans-serif;line-height:1'> <p style='margin:0px;text-align:center;line-height:inherit'><span style='color:rgb(255,160,122)'><b><span style='font-size:48px'></span></b> </span> </p><p style='margin:0px;text-align:center;line-height:inherit'><span style='font-size:22px'><b>Caso você tenha alguma dúvida, por favor, entre em contato com a sua comissão de formatura</b></span></p></td></tr></tbody> </table> </td></tr></tbody> </table> </div></td></tr></tbody> </table> </td></tr></tbody></table></body></html>
		`;
  }
  // data.login.email e data.login.senha
  static templateAcessoComissao(data) {
    return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Acesso ao Sistema - Alpha Convites</title>
</head>
<body style="margin:0;padding:0;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;background-color:#f5f5f5;">
  <table width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f5f5f5;">
    <tr>
      <td align="center" style="padding:40px 20px;">
        <table width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:600px;background-color:#ffffff;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.05);">
          <!-- Título -->
          <tr>
            <td align="center" style="padding:30px 40px 10px 40px;">
              <h1 style="margin:0;font-size:28px;font-weight:600;color:#333;line-height:1.4;">Olá!</h1>
              <p style="margin:10px 0 0 0;font-size:18px;color:#666;line-height:1.6;">Comissão de Formatura</p>
              <p style="margin:8px 0 0 0;font-size:14px;color:#999;font-weight:500;">Guarde muito bem essa informação!</p>
            </td>
          </tr>
          <!-- Imagem com link -->
          <tr>
            <td align="center" style="padding:20px 40px;">
              <a href="https://areadoformando.alphaeditora.com.br/login" target="_blank">
                <img src="https://alphaplay.alphaconvites.com.br/imagens-marketing/email-agencia/formando_acesso.jpg" alt="Acessar Sistema" style="width:100%;max-width:500px;display:block;border-radius:6px;" />
              </a>
            </td>
          </tr>
          <!-- Credenciais -->
          <tr>
            <td style="padding:0 40px 30px 40px;">
              <div style="background-color:#f8f9fa;border-radius:6px;padding:24px;text-align:center;">
                <p style="margin:0 0 16px 0;font-size:15px;color:#555;font-weight:600;">Suas credenciais de acesso:</p>
                <div style="margin-bottom:12px;">
                  <span style="font-size:13px;color:#999;text-transform:uppercase;letter-spacing:0.5px;">Login</span>
                  <p style="margin:4px 0 0 0;font-size:16px;color:#FF6B6B;font-weight:600;">${data.login.email}</p>
                </div>
                <div>
                  <span style="font-size:13px;color:#999;text-transform:uppercase;letter-spacing:0.5px;">Senha</span>
                  <p style="margin:4px 0 0 0;font-size:16px;color:#FF6B6B;font-weight:600;">${data.login.senha}</p>
                </div>
              </div>
            </td>
          </tr>
          <!-- Info adicional -->
          <tr>
            <td style="padding:0 40px 30px 40px;">
              <p style="margin:0;font-size:14px;color:#666;line-height:1.6;text-align:center;">Você já pode acessar o sistema. Na área da comissão há um tutorial completo explicando todas as funcionalidades.</p>
            </td>
          </tr>
          <!-- Divisor -->
          <tr>
            <td style="padding:0 40px;">
              <div style="height:1px;background-color:#e5e5e5;"></div>
            </td>
          </tr>
          <!-- Footer -->
          <tr>
            <td align="center" style="padding:30px 40px;">
              <p style="margin:0;font-size:14px;color:#999;line-height:1.6;">Caso você tenha alguma dúvida, por favor, entre em contato com a sua comissão de formatura</p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`;
  }
  // usuario.nome, usuario.email e usuario.senha
  static templateAcessoFormando(usuario) {
    return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Acesso ao Sistema - Alpha Convites</title>
</head>
<body style="margin:0;padding:0;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,'Helvetica Neue',Arial,sans-serif;background-color:#f5f5f5;">
  <table width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color:#f5f5f5;">
    <tr>
      <td align="center" style="padding:40px 20px;">
        <table width="100%" cellspacing="0" cellpadding="0" border="0" style="max-width:600px;background-color:#ffffff;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.05);">
          <!-- Título -->
          <tr>
            <td align="center" style="padding:30px 40px 10px 40px;">
              <h1 style="margin:0;font-size:28px;font-weight:600;color:#333;line-height:1.4;">Olá, ${usuario.nome}!</h1>
              <p style="margin:10px 0 0 0;font-size:18px;color:#666;line-height:1.6;">Aqui você encontrará as suas informações de acesso</p>
              <p style="margin:8px 0 0 0;font-size:14px;color:#999;font-weight:500;">Guarde muito bem essa informação!</p>
            </td>
          </tr>
          <!-- Imagem com link -->
          <tr>
            <td align="center" style="padding:20px 40px;">
              <a href="https://areadoformando.alphaeditora.com.br/login" target="_blank">
                <img src="https://alphaplay.alphaconvites.com.br/imagens-marketing/email-agencia/formando_acesso.jpg" alt="Acessar Sistema" style="width:100%;max-width:500px;display:block;border-radius:6px;" />
              </a>
            </td>
          </tr>
          <!-- Credenciais -->
          <tr>
            <td style="padding:0 40px 30px 40px;">
              <div style="background-color:#f8f9fa;border-radius:6px;padding:24px;text-align:center;">
                <p style="margin:0 0 16px 0;font-size:15px;color:#555;font-weight:600;">Suas credenciais de acesso:</p>
                <div style="margin-bottom:12px;">
                  <span style="font-size:13px;color:#999;text-transform:uppercase;letter-spacing:0.5px;">Login</span>
                  <p style="margin:4px 0 0 0;font-size:16px;color:#FF6B6B;font-weight:600;">${usuario.email}</p>
                </div>
                <div>
                  <span style="font-size:13px;color:#999;text-transform:uppercase;letter-spacing:0.5px;">Senha</span>
                  <p style="margin:4px 0 0 0;font-size:16px;color:#FF6B6B;font-weight:600;">${usuario.senha}</p>
                </div>
              </div>
            </td>
          </tr>
          <!-- Divisor -->
          <tr>
            <td style="padding:0 40px;">
              <div style="height:1px;background-color:#e5e5e5;"></div>
            </td>
          </tr>
          <!-- Footer -->
          <tr>
            <td align="center" style="padding:30px 40px;">
              <p style="margin:0;font-size:14px;color:#999;line-height:1.6;">Caso você tenha alguma dúvida, por favor, entre em contato com a sua comissão de formatura</p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</body>
</html>`;
  }
  // numContrato
  static templateVinculacaoDeContrato(numContrato) {
    return `<html><body>O contrato ${numContrato} foi vinculado a você e já está disponível para ser acessado no sistema da Agência/Cronograma.</body></html>`;
  }
  // dadosAntigos.nome, dadosAntigos.email e dadosAntigos.telefone
  static templateAlteracaoDadosContato(
    numContrato,
    dadosAntigos,
    novosDados,
    usuario
  ) {
    return `<html><body>Alteração de contato <br/><br/><strong>ALTERAR</strong> o contato no contrato <strong>${numContrato}</strong><br/><br/><br/>Informações antigas:<br/><br/><strong>Nome:</strong> ${
      dadosAntigos.nome
    }<br/><strong>E-mail:</strong> ${
      dadosAntigos.email
    }<br/><strong>Telefone:</strong> ${
      dadosAntigos.telefone
    }<br/><strong>Outro telefone:</strong> ${
      dadosAntigos.outroTelefone ? dadosAntigos.outroTelefone : ''
    }<br/><br/><br/>Novas informações: <br/>${novosDados}<br/><br/>Solicitado por: ${usuario}</body></html>`;
  }
  // novosDados.nome, novosDados.email e novosDados.telefone
  static templateAdicionarContato(numContrato, novosDados, usuario) {
    return `<html><body>Adição de contato <br/><br/><strong>ADICIONE</strong> o contato no contrato <strong>${numContrato}</strong><br/><br/><br/>Informações do contato:<br/><br/><strong>Nome:</strong> ${novosDados.nome}<br/><strong>E-mail:</strong> ${novosDados.email}<br/><strong>Telefone:</strong> ${novosDados.telefone}<br/><strong>Outro telefone:</strong> ${novosDados.outroTelefone}<br/><br/>Solicitado por: ${usuario}</body></html>`;
  }

  static getAcessoComissaoToComissao(data) {
    return {
      subjectMatter: 'Senha de Acesso ao Sistema - Alpha Convites',
      mailName: 'Alpha Convites',
      destinatario: data.usuario.email,
      file: new Blob([this.templateAcessoComissao(data)], {
        type: 'text/plain',
      }),
    };
  }
  static getAcessoComissaoToDesigner(contrato) {
    return {
      subjectMatter: `Contrato ${contrato.numero} foi vinculado a você!`,
      mailName: 'Alpha Convites',
      destinatario: contrato.designer.email,
      file: new Blob([this.templateVinculacaoDeContrato(contrato.numero)], {
        type: 'text/plain',
      }),
    };
  }
  static getAcessoDesigner(contrato) {
    return {
      subjectMatter: `Senha de Acesso ao Sistema de Personalização - Alpha Convites`,
      mailName: 'Alpha Convites',
      destinatario: contrato.usuario.email,
      file: new Blob([this.templateAcessoComissao(contrato.usuario)], {
        type: 'text/plain',
      }),
    };
  }
  static getAlteracaoDadosContato(data) {
    let novosDados = data.novosDados
      ? data.novosDados.replace(/\n/g, '<br/>')
      : data.novosDados;
    return {
      subjectMatter: `Alteração de contato - METRICS/MAPAVENDAS`,
      mailName: 'Alpha Convites',
      destinatario: EMAIL_SUPORTE,
      file: new Blob(
        [
          this.templateAlteracaoDadosContato(
            data.numContrato,
            data.dadosAntigos,
            novosDados,
            data.solicitadoPor
          ),
        ],
        { type: 'text/plain' }
      ),
    };
  }
  static getAdicionarContato(data) {
    return {
      subjectMatter: `Adição de contato - METRICS/MAPAVENDAS`,
      mailName: 'Alpha Convites',
      destinatario: EMAIL_SUPORTE,
      file: new Blob(
        [
          this.templateAdicionarContato(
            data.numContrato,
            data.novosDados,
            data.solicitadoPor
          ),
        ],
        { type: 'text/plain' }
      ),
    };
  }
  static getAcessoFormando(data) {
    return {
      subjectMatter: `Senha de Acesso ao Sistema - Alpha Convites`,
      mailName: 'Alpha Convites',
      destinatario: data.email,
      file: new Blob([this.templateAcessoFormando(data)], {
        type: 'text/plain',
      }),
    };
  }
  static getLiberacaoPlanilhaQtd(data) {
    return {
      subjectMatter: `Liberação da planilha de quantidades - Alpha Convites`,
      mailName: 'Alpha Convites',
      destinatario: data.email,
      file: new Blob([this.templateLiberacaoPlanilhaQtd()], {
        type: 'text/plain',
      }),
    };
  }
}

export default class EmailServices {
  enviar(tipo, contrato, notify = true) {
    let config = '',
      urlTemporaria = '',
      formData = new FormData();
    switch (tipo) {
      case 'comissao':
        config = Mail.getAcessoComissaoToComissao(contrato);
        break;
      case 'formando':
        config = Mail.getAcessoFormando(contrato.usuario);
        break;
      case 'comissaoDesigner':
        config = Mail.getAcessoComissaoToDesigner(contrato);
        break;
      case 'liberacaoPlanilhaQtd':
        config = Mail.getLiberacaoPlanilhaQtd(contrato.usuario);
        break;
      // case "formando":
      // 	config = Mail.getAcessoDesigner(contrato.usuario);
      // 	break;
      case 'alterarDadosContato':
        config = Mail.getAlteracaoDadosContato(contrato);
        break;
      case 'adicionarContato':
        config = Mail.getAdicionarContato(contrato);
        break;
    }
    urlTemporaria = URL.createObjectURL(config.file);
    return Mail.urltoFile(urlTemporaria, 'html.html', 'text/plain').then(
      function (file) {
        let nome =
          contrato.usuario.nome !== undefined && contrato.usuario.nome !== ''
            ? contrato.usuario.nome
            : config.destinatario;
        formData.append('html', file);
        formData.append('name', nome);
        formData.append('email', config.destinatario);
        formData.append('mailName', config.mailName);
        formData.append('subjectMatter', config.subjectMatter);
        return axios
          .post(`${URL_EMAIL}/send/new-send`, formData)
          .then((response) => {
            if (notify) {
              let msg = 'E-mail enviado com sucesso';
              if (tipo === 'comissao') {
                msg += ` para ${config.destinatario}`;
              }
              toast.success(`${msg}!`);
            }
            return true;
          })
          .catch((erro) => {
            if (notify) {
              let msg = 'Não foi possível enviar o e-mail';
              if (tipo === 'comissao') {
                msg += ` para ${config.destinatario}`;
              }
              toast.error(`${msg}!`);
            }
            return false;
          });
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/email.js